import Input from 'component/atom/forms/input/input/Input';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import styles from './QuestionForm.module.scss';
import React, { useState } from 'react';
import Button from 'component/atom/forms/button/Button';
import toast from 'react-hot-toast';

const QuestionForm = ({ formik, nodeId }) => {
  const [sections, setSections] = useState(formik.values.question.length);

  const addSection = () => {
    const newIndex = formik.values.question.length;
    formik.setFieldValue('question', [
      ...formik.values.question,
      {
        questionText: '',
        sourceHandle: `source-${nodeId}-${newIndex}`,
      },
    ]);
    setSections(sections + 1);
  };

  const removeSection = (index) => {
    if (formik.values.question.length === 1) {
      toast.error('At least one question is required.');
      return;
    }

    const newQuestions = formik.values.question
      .filter((_, i) => i !== index)
      .map((q, i) => ({
        ...q,
        sourceHandle: `source-${nodeId}-${i}`,
      }));

    formik.setFieldValue('question', newQuestions);
    setSections(sections - 1);
  };

  return (
    <form
      className={styles['question-form']}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <div className={styles['label-container']}>
        <p className={styles['label']}>Questions</p>
        <Button
          type="plus"
          className={styles['button']}
          buttonType="button"
          transparent
          onClick={addSection}
        />
      </div>
      <div className={styles['questions-container']}>
        {formik.values.question.map((q, index) => (
          <div className={styles['multi-input']} key={index}>
            <Input
              name={`question[${index}].questionText`}
              value={q.questionText}
              onChange={formik.handleChange}
              error={formik.errors?.question?.[index]?.questionText}
              touched={formik.touched?.question?.[index]?.questionText}
              placeholder="Enter a question"
            />
            <SvgWithBranding
              type="delete_table"
              className={styles['icon']}
              onClick={() => removeSection(index)}
            />
          </div>
        ))}
      </div>
    </form>
  );
};

export default QuestionForm;
